import { render } from "./PuzzleCaptcha.vue?vue&type=template&id=b492c74a&scoped=true"
import script from "./PuzzleCaptcha.vue?vue&type=script&lang=js"
export * from "./PuzzleCaptcha.vue?vue&type=script&lang=js"

import "./PuzzleCaptcha.vue?vue&type=style&index=0&id=b492c74a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b492c74a"]])

export default __exports__